import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers';
import { AppRouter } from './app/router';
import { bootstrapModules } from './modules';

/**
 * Subida do aplicativo.
 *
 * O import dos mocks e DINAMICO e fica atras de `import.meta.env.DEV`, que o
 * Vite substitui por uma constante no build. Em producao o ramo inteiro e
 * eliminado e a configuracao-semente — uns 20 kB de planos, formularios e
 * anuncios de exemplo — nao chega a ser empacotada.
 *
 * Um `if` comum sobre variavel de ambiente nao garante isso: basta a condicao
 * deixar de ser constante para o empacotador manter tudo por precaucao.
 */
async function bootstrap(): Promise<void> {
  let DevMailbox: (() => JSX.Element | null) | null = null;

  if (import.meta.env.DEV) {
    const { installMocks } = await import('./mocks/install');
    installMocks();

    // Caixa de entrada de desenvolvimento: mostra os e-mails que teriam sido
    // enviados, para os fluxos de confirmação e recuperação serem testáveis
    // sem servidor de e-mail.
    ({ DevMailbox } = await import('./mocks/DevMailbox'));
  }

  // Modulos antes do roteador: ele so monta o que estiver registrado.
  bootstrapModules();

  const container = document.getElementById('root');
  if (!container) throw new Error('Elemento #root nao encontrado.');

  createRoot(container).render(
    <StrictMode>
      <AppProviders>
        <AppRouter />
        {DevMailbox ? <DevMailbox /> : null}
      </AppProviders>
    </StrictMode>,
  );
}

void bootstrap();
